import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import Icon from '@components/Icon/Icon';

const AttachmentActions = ({
    editable,
    canCrop,
    canAIEdit,
    isCropping,
    isAIEditing,
    onCrop,
    onAIEdit,
    onDelete
}) => {
    const { t } = useLanguage();

    if (!editable) return null;

    return (
        <div className="attachment-actions">
            {canCrop && (
                <button
                    type="button"
                    onClick={onCrop}
                    disabled={isCropping}
                    className="action-btn crop-btn"
                    title={t('attachments.crop.title')}
                >
                    <Icon icon={isCropping ? "spinner" : "crop"} spin={isCropping} />
                </button>
            )}

            {canAIEdit && (
                <button
                    type="button"
                    onClick={onAIEdit}
                    disabled={isAIEditing}
                    className="action-btn ai-edit-btn"
                    title={t('attachments.editWithAI')}
                >
                    <Icon icon={isAIEditing ? "spinner" : "wand-magic-sparkles"} spin={isAIEditing} />
                </button>
            )}

            <button
                type="button"
                onClick={onDelete}
                className="action-btn delete-btn"
                title={t('attachments.delete')}
            >
                <Icon icon="trash" />
            </button>
        </div>
    );
};

export default AttachmentActions;
